const pascalCaseToWords = (text) => {
  if (!text) {
    return '';
  }

  return text.replace(/([A-Z])/g, ' $1').trim();
};

export default pascalCaseToWords;
